
import '../../App.css';
import React, { useRef } from 'react';
import { data } from './privacyPolicyData';
import { termsOfServiceData } from './termsOfServiceData';
import owaa4 from '../../images/owaa4.jpg'
import Footer from '../../components/Footer.js';
import Header from '../../components/Header';
const PrivayPolicy = () => {
    const feature = useRef(null);
    const gotoFeature = () => window.scrollTo({ top: feature.current.offsetTop, behaviour: "smooth" })
    return (
        <body className='font-Poppins'>
            {/* header */}
            <Header gotoFeature={gotoFeature} />

            {/* Hero */}
            <section className='relative'>
                <div className='container flex flex-col-reverse lg:flex-row items-center gap-12 mt-14 lg:mt-18'>
                    {/* Image */}
                    <div className='flex justify-center flex-1 mb-10 md:mb-16 lg:mb-0 z-10'>
                        <img src={owaa4} alt="Logo" className="rounded-md w-3/5 h-3/5" />
                    </div>
                </div>
            </section>

            {/* privacy policy */}
            <section className='relative'>
                <div className='container mt-14 lg:mt-18'>
                    {/* content */}
                    <h1 className='text-3xl text-center text-primary mb-10'>privacy policy</h1>
                    <p className='ml-8 leading-8'>
                        We take the responsibility of protecting the personal information
                        provided to us seriously. We’ll be explaining how we do that when you
                        use any of our services.  <br />
                        We may make changes to this Privacy Policy from time to time, and the
                        revised version will be effective when it is posted. When updates are
                        done we will ensure to provide notifications through the Service or by
                        other methods.  <br />
                        This Statement of Privacy sets out what we do with the personal
                        information we collect and how we protect it, and it explains your
                        privacy rights (if applicable).  <br />
                        When you post any information or other content to a public online
                        community or forum using the Services or when you post information on
                        any Owaa social media page, such information and/or other content is
                        viewable to anyone on the Internet.  This public information may be
                        collected and used by others without your or our knowledge, and the
                        security and other protective provisions of this Privacy Policy do not
                        apply.  <br />
                        We collect personal information provided to us and we do not share those information with anyone. We only use them to serve you better. <br /><br />
                    </p>
                    {data.map((item, i) => (
                        <div className='mb-13 flex flex-row leading-8'>
                            <p className='mb-2 font-bold'>{i + 1}</p>
                            <p className='ml-8'>{item.body}</p>
                        </div>
                    ))}
                    <br /><br />
                </div>
            </section>

            {/* privacy policy */}
            <section className='relative'>
                <div className='container mt-14 lg:mt-18'>
                    {/* content */}
                    <h1 className='text-3xl text-center text-primary mb-10'>terms of service</h1>
                    <p className='ml-8 leading-8'>
                        Thank you for using Owaa.
                        We offer a real estate management solution that helps real estate
                        owners and investors manage, track, and communicate the performance of
                        their real estate assets. We do this by allowing real estate owners
                        and investors update all relevant data about their real estate assets.
                        Owaa enables you to consolidate and stay on top of your real estate
                        data, making it easy for both novice and sophisticated real estate
                        owners to monitor and analyze assets.
                        These terms of service cover your use and access to our mobile app,
                        and services. By accessing or using the Service, you agree to be bound
                        by these Terms. If you are using our Service for an organization,
                        you’re agreeing to these Terms on behalf of that organization. It is
                        the responsibility of you, the user, to read the Terms before
                        proceeding to use this app. If you disagree with any part of the
                        Terms, then you may not use the Service
                    </p>
                    {termsOfServiceData.map((item, i) => (
                        <div className='mb-4 leading-8'>
                            <p className='font-bold'>{item.title}</p>
                            <p>{item.body}</p>
                        </div>
                    ))}
                    <br /><br />
                    <p>We do not sell your personal information for money or other consideration.</p>
                </div>
            </section>

            {/* footer */}
            <Footer />
        </body >
    );
}

export default PrivayPolicy;
